function deepMerge(target, source) {
  const keys = Object.keys(source);
  /* eslint-disable no-param-reassign */
  for (let i = 0; i < keys.length; i += 1) {
    const key = keys[i];
    if (source[key] && typeof source[key] === 'object' && !Array.isArray(source[key])) {
      if (!target[key]) {
        target[key] = {};
      }
      this.deepMerge(target[key], source[key]);
    } else if (Array.isArray(source[key])) {
      while (target[key].length > 0) {
        target[key].pop();
      }
      for (let j = 0; j < source[key].length; j += 1) {
        target[key].push(source[key][j]);
      }
    } else {
      target[key] = source[key];
    }
  }
  /* eslint-enable no-param-reassign */
}

export default deepMerge;
